import * as types from './actionTypes'
import { api } from 'utils/redux/apiThunks'

export function calculatedRate (json) {
	return {
		type: types.CALCULATED_RATE,
		calculatedRate: json
	}
}

function calcRequest (uri, data, formData) {
	const { isSwitched } = data
	return dispatch => { 
		api.post(uri, { body: formData })
			.then(response => response.json())
			.then(json => dispatch(calculatedRate({
				...json,
				toCurrency: data.toCurrency,
				fromCurrency: data.fromCurrency,
				isSwitched
			})))
	}
} 
export function calculateRate (data = {}) {
	const formData = {
		amount: data.amount,
		...data.fromCurrency.abbreviature !== 'BGN' ? { from_currency_id: data.fromCurrency.value } : {},
		...data.toCurrency.abbreviature !== 'BGN' ? { to_currency_id: data.toCurrency.value } : {},
	}
	return calcRequest('rates', data, formData)
}

export function calculateCryptoRate (data = {}) {
	const formData = {
		amount: data.amount,
		...data.fromCurrency.abbreviature !== 'BGN' ? { ...data.fromCurrency.isCrypto ? { from_crypto_currency_id: data.fromCurrency.value} : { from_currency_id: data.fromCurrency.value} } : {},
		...data.toCurrency.abbreviature !== 'BGN' ? { ...data.toCurrency.isCrypto ? { to_crypto_currency_id: data.toCurrency.value } : { to_currency_id: data.toCurrency.value } } : {},
	}
	return calcRequest('cryptorates', data, formData)
}

export function resetRate () {
	return {
		type: types.RESET_RATE,
	}
}

export function switchCurrencies () {
	return (dispatch, getState) => {
		const state = getState()
		const fromCurrency = state.calculatedRate.fromCurrency || null
		const toCurrency = state.calculatedRate.toCurrency || null
		const isSwitched = !state.calculatedRate.isSwitched
		return dispatch(calculatedRate({
			fromCurrency: toCurrency,
			toCurrency: fromCurrency,
			isSwitched
		}))
	}
}

export function resetCalculator () {
	return {
		type: types.CALCULATED_RATE,
		calculatedRate: {
			fromCurrency: null,
			toCurrency: null,
			isSwitched: false,
			total: null
		}
	}
}
